import React from 'react';

function HelpMessage() {
  return (
    <div>
      <h3>All Income</h3>
      <p>
        Shows the monthly income sources for the last 12 months.
      </p>
      <h3>Self-reported Income</h3>
      <p>
        The total monthly income reported in the application.
      </p>
      <h3>Selected Income</h3>
      <p>
        The sum of selected income sources.
      </p>
      <h5>Net/Gross toggle</h5>
      <p>
        You can toggle to display either the net income or the estimated gross income in the All Income
        and Selected Income sections.
      </p>
      <h5>Calculation Summary</h5>
      <p>
        You can click on the arrows next to each heading to see how the total is calculated.
      </p>
      <h3>Recent Income & Credit Sources</h3>
      <p>
        Includes income sources that have appeared in the last 3 months.
      </p>
      <h5>Recent Income</h5>
      <p>
        Includes sources classified as income.
      </p>
      <h5>Other Credits</h5>
      <p>
        Includes one-off and other transactions that resemble income, but the system has not classified as income.
      </p>
      <h4>Fields</h4>
      <b>Description</b>
      <p>
        The description of the income source from the corresponding transactions.
      </p>
      <b>Net Income</b>
      <p>
        The average net monthly amount of the income source.
      </p>
      <b>Est. Gross Income</b>
      <p>
        The average estimated gross monthly amount of the income source.
      </p>
      <b>Stability</b>
      <p>
        A metric indicating the reliability of the income source.
      </p>
      <b>Next payment</b>
      <p>
        The predicted date of the next payment from this income source.
      </p>
      <b>First Occurance</b>
      <p>
        The date of the first transaction for this income source.
      </p>
      <b>Last Occurance</b>
      <p>
        The date of the most recent transaction for this income source.
      </p>
      <b>Income Category</b>
      <p>
        The type of income source. Government subsidy, paycheck, etc. This can have multiple subcategories.
      </p>
      <b>Frequency</b>
      <p>
        The frequency of the income source. Weekly, bi-weekly, monthly, etc.
      </p>
      <b>Average End of Day Balance after Payday</b>
      <p>
        Shows the average end of day balances after the payday of the given income source.
      </p>
      <b>Transactions</b>
      <p>
        You can click on the arrow on the right side of each income source card to see the transactions corresponding to that income source.
      </p>
    </div>
  );
}

export default HelpMessage;
